import { Icon } from "@/components/icons";

export function MutedSearchTrigger({
  placeholder = "Search",
  count = 0,
  unit = "selected",
  unitPlural,
  onClick,
  buttonRef,
  size = "sm",
}: {
  placeholder?: string;
  count?: number;
  unit?: string;
  unitPlural?: string;
  onClick: () => void;
  buttonRef?: (node: HTMLButtonElement | null) => void;
  /** "sm" = compact (filter cards), "md" = 40px to match dropdown height in forms. */
  size?: "sm" | "md";
}) {
  const plural = unitPlural ?? `${unit}s`;
  const padClass = size === "md" ? "px-3 py-2" : "p-2";
  const textClass = size === "md" ? "text-body" : "text-small";
  return (
    <button
      ref={buttonRef}
      type="button"
      onClick={onClick}
      className={`flex w-full items-center gap-1.5 rounded-sm bg-grey-100 ${padClass} text-left transition-colors hover:bg-grey-200`}
    >
      <Icon name="search" size={20} className="text-grey-600" />
      <span
        className={`min-w-0 flex-1 truncate ${textClass} ${
          count > 0 ? "text-grey-900" : "text-grey-600"
        }`}
      >
        {count > 0
          ? unit === "selected"
            ? `${count} selected`
            : `${count} ${count === 1 ? unit : plural} selected`
          : placeholder}
      </span>
    </button>
  );
}
